import React from 'react'
import noop from 'lib/function/noop'
import LuxkitModalBehaviourState, { LuxkitModalBehaviourDispatchAction } from './LuxkitModalBehaviourState'

export const LuxkitModalBehaviourStateContext = React.createContext<LuxkitModalBehaviourState>({})
export const LuxkitModalBehaviourDispatchContext = React.createContext<React.Dispatch<LuxkitModalBehaviourDispatchAction>>(noop)
